import { render } from "./FlightDetailsView.vue?vue&type=template&id=416d6d22&scoped=true"
import script from "./FlightDetailsView.vue?vue&type=script&lang=js"
export * from "./FlightDetailsView.vue?vue&type=script&lang=js"

import "./FlightDetailsView.vue?vue&type=style&index=0&id=416d6d22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416d6d22"]])

export default __exports__